import { type FC } from 'react';

interface AdSlotProps {
  type: 'kakao' | 'google';
  adUnitId?: string;
  adSlot?: string;
  width?: number;
  height?: number;
  className?: string;
}

/**
 * 광고 슬롯 컴포넌트
 * - Kakao AdFit, Google AdSense 모두 지원
 * - 광고 ID 미설정 시 점선 플레이스홀더 표시
 * - 실제 광고 적용 시 adUnitId / adSlot 값을 실제 ID로 교체
 */
const AdSlot: FC<AdSlotProps> = ({
  type,
  adUnitId,
  adSlot,
  width = 728,
  height = 90,
  className = '',
}) => {
  const hasAd = !!adUnitId;

  return (
    <div className={`w-full flex flex-col items-center ${className}`}>
      {/* 광고 라벨 — 법적 필수 */}
      <span className="text-[10px] text-foreground-300 tracking-wider mb-1.5 uppercase">
        ADVERTISEMENT
      </span>

      <div
        className={`
          relative w-full overflow-hidden
          flex items-center justify-center
          ${hasAd
            ? ''
            : 'border border-dashed border-background-300 rounded-xl bg-background-100/50'
          }
        `}
        style={{ maxWidth: width, minHeight: height }}
      >
        {hasAd ? (
          type === 'kakao' ? (
            <ins
              className="kakao_ad_area"
              style={{ display: 'none' }}
              data-ad-unit={adUnitId}
              data-ad-width={String(width)}
              data-ad-height={String(height)}
            />
          ) : (
            <ins
              className="adsbygoogle"
              style={{ display: 'block' }}
              data-ad-client={adUnitId}
              data-ad-slot={adSlot || ''}
              data-ad-format="auto"
              data-full-width-responsive="true"
            />
          )
        ) : (
          <div className="flex flex-col items-center gap-2 py-6 px-4">
            <div className="w-8 h-8 rounded-full bg-background-200 flex items-center justify-center">
              <i className="ri-advertisement-line text-foreground-400 text-sm"></i>
            </div>
            <p className="text-foreground-400 text-xs text-center">
              광고 영역
              <br />
              <span className="text-foreground-300">
                {type === 'kakao' ? 'Kakao AdFit' : 'Google AdSense'} 광고가 여기에 표시됩니다
              </span>
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdSlot;